<template>
    <div>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            key-property="envId"
            search-url="/envIndex/search"
            create-url="/envIndex/save"
            delete-url="/envIndex/delete"
            form-type="intable"
            custom-create-new
            @createNew="openEnvDialog"
            custom-edit-item
            @editItem="openEnvDialog"
            ref="tableData"
            :reload="timeReload"
            deleteMulti="false"
            :acceptDelete="false"
        >
        </c-search-form>
        <env-index-create
            :envIndex="envItem"
            :cDialog="visibleEnvDialog"
            :units="units"
            @closeEnvDialog="closeEnvDialog"
        />
    </div>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import EnvIndexCreate from "./EnvIndexCreate.vue";
import axios from "axios";
import { cateContants } from "@/constants";

export default {
    name: "env-index",
    components: { EnvIndexCreate, CSearchForm },
    data: () => {
        return {
            formName: "Danh sách chỉ số môi trường",
            envItem: null,
            visibleEnvDialog: false,
            units: [],
            timeReload: 0,
            fields: [
                {
                    value: "index",
                    text: "lang.common.index",
                    width: "5%",
                    sortable: false,
                    headerStyle: "text-align:center",
                },
                {
                    value: "envName",
                    text: "Tên chỉ số",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "unitType",
                    text: "Đơn vị",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                // {
                //     value: "unitTypeId",
                //     text: "Đơn vị",
                //     sortable: false,
                //     search: true,
                //     headerStyle: "text-align:center",
                //     type: "select",
                //     name: 'unitTypeId',
                //     items: [],
                //     itemText: "categoryName",
                //     itemValue: "categoryId",
                // },
                // {
                //     value: "maxValue",
                //     text: "Giá trị cho phép",
                //     width: "10%",
                //     sortable: false,
                //     search: false,
                //     headerStyle: "text-align:center",
                // },
                // {
                //     value: "mediumValue",
                //     text: "Giá trị trung bình",
                //     width: "10%",
                //     sortable: false,
                //     search: false,
                //     headerStyle: "text-align:center",
                // },
                // {
                //     value: "minValue",
                //     text: "Giá trị tối thiểu",
                //     width: "10%",
                //     sortable: false,
                //     search: false,
                //     headerStyle: "text-align:center",
                // },
                {
                    value: "status",
                    text: "lang.user.status",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "status",
                    items: cateContants.areaStatus,
                    itemText: "text",
                    itemValue: "value",
                },
                {
                    value: "action",
                    text: "lang.common.actions",
                    width: "60px",
                    sortable: false,
                    compound: true,
                    headerStyle: "text-align:center",
                },
            ],
        };
    },

    created() {
        axios
            .post(
                process.env.VUE_APP_API_URL + "/category/listByType?type=ENVINDEX"
            )
            .then(
                (data) => {
                    if (data.length > 0) {
                        this.units = data;
                        let itemFields = this.fields.filter(function (e) {
                            return e.value == "unitTypeId";
                        });
                        if (itemFields != undefined && itemFields.length > 0) {
                            itemFields[0].items = data;
                        }
                    }
                }
            );
    },

    methods: {
        openEnvDialog: function (item = null) {
            this.envItem = item;
            this.visibleEnvDialog = true;
        },
        closeEnvDialog: function () {
            this.envItem = null;
            this.visibleEnvDialog = false;
            this.timeReload = Math.floor(Math.random() * 100);
        },
    },

    destroyed() {},
};
</script>
